import React from 'react';
import { ModuleContentTemplate } from './ModuleContentTemplate';
import { module8Config } from '../config/moduleConfigs';

interface User {
  id: string;
  email: string;
  fullName: string;
  company: string;
  role: string;
  status: string;
}

interface Module8ContentProps {
  user: User | null;
  onLogout: () => void;
  isPreviewMode?: boolean;
  invitationEmail?: string;
  isAdminMode?: boolean;
  inviteToken?: string;
}

export function Module8Content({ 
  user, 
  onLogout, 
  isPreviewMode = false, 
  invitationEmail, 
  isAdminMode = false, 
  inviteToken 
}: Module8ContentProps) {
  return (
    <ModuleContentTemplate
      user={user}
      onLogout={onLogout}
      moduleId={8}
      moduleConfig={module8Config}
      isPreviewMode={isPreviewMode}
      invitationEmail={invitationEmail}
      isAdminMode={isAdminMode}
      inviteToken={inviteToken}
    />
  );
}

